// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__130n3","productName":"Table_productName__Jl3XD"};